// Who plays (WI-37). "Plays" (earns plays, wins prizes, has a Learn goal) and "can't organise"
// (no PIN, no admin rights) used to be one check, `kind === 'child'`. They're two now: every
// child plays, a grown-up plays when they join in, and a solo traveller is a family of one whose
// grown-up plays. Keep `kind` checks for organising; use these for playing.
import { playsOf, type Person } from '../../shared/events'

export { playsOf }

type Who = Pick<Person, 'kind' | 'plays'>

/** A grown-up who plays: nobody above them, so they cash in their own prizes. */
export const grownUpPlayer = (p: Who): boolean => p.kind !== 'child' && playsOf(p)

/** The players among `people`, in order. */
export const playersOf = <P extends Who>(people: readonly P[]): P[] => people.filter(playsOf)

/** "Set it up › Just me": a family of one whose grown-up plays (no children, nobody to ask). */
export const isSolo = (people: readonly Who[] | null | undefined): boolean => people?.length === 1 && grownUpPlayer(people[0]!)
